<template>
    <div class="section-card-component" :class="customClass">
        <div class="section-card-component__header" v-if="hasHeader">
            <div class="section-card-component__heading">
                <div class="section-card-component__icon" v-if="icon">
                    <i :class="icon"></i>
                </div>
                <div class="section-card-component__title-block">
                    <span class="section-card-component__eyebrow" v-if="eyebrow">{{ eyebrow }}</span>
                    <h6 v-if="title" :class="titleClass">{{ title }}</h6>
                    <small v-if="subtitle || $slots.subtitle">
                        <slot name="subtitle">{{ subtitle }}</slot>
                    </small>
                </div>
            </div>

            <div class="section-card-component__actions" v-if="counter || $slots.actions">
                <slot name="actions">
                    <span class="section-card-component__counter">{{ counter }}</span>
                </slot>
            </div>
        </div>

        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'SectionCardComponent',
    props: {
        eyebrow: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        counter: {
            type: String,
            default: '',
        },
        customClass: {
            type: [String, Array, Object],
            default: '',
        },
        titleClass: {
            type: [String, Array, Object],
            default: '',
        },
    },
    computed: {
        hasHeader() {
            return this.eyebrow || this.title || this.subtitle || this.icon || this.counter || this.$slots.subtitle || this.$slots.actions;
        },
    },
}
</script>

<style scoped>
.section-card-component {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.08), rgba(14, 94, 78, 0.035) 24%, transparent 58%),
        linear-gradient(135deg, #ffffff 0%, #fbfcfd 58%, #f7f9fb 100%);
    border: 1px solid #dce3ea;
    border-radius: 14px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.88),
        0 12px 28px rgba(15, 23, 42, 0.06);
    margin-bottom: 10px;
    padding: 18px 18px 4px;
}

.section-card-component__header {
    align-items: flex-start;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    margin-bottom: 14px;
}

.section-card-component__heading {
    align-items: flex-start;
    display: flex;
    gap: 12px;
    min-width: 0;
}

.section-card-component__icon {
    align-items: center;
    background: #e7f4f0;
    border-radius: 12px;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 40px;
    height: 40px;
    justify-content: center;
    width: 40px;
}

.section-card-component__title-block {
    min-width: 0;
}

.section-card-component__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
}

.section-card-component h6 {
    color: #173b34;
    font-weight: 700;
    margin: 2px 0;
}

.section-card-component small {
    color: #6b7c78;
}

.section-card-component__counter {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    display: inline-flex;
    font-size: 12px;
    font-weight: 700;
    padding: 8px 12px;
    white-space: nowrap;
}

:global(html.dark-theme .section-card-component ){
    background:
        radial-gradient(ellipse at 0% 0%, rgba(20, 184, 166, 0.20), rgba(20, 184, 166, 0.10) 24%, transparent 58%),
        linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: rgba(94, 234, 212, 0.18) !important;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.04),
        inset 0 0 0 1px rgba(148, 163, 184, 0.08),
        -14px -12px 38px rgba(20, 184, 166, 0.11),
        0 18px 42px rgba(2, 6, 23, 0.36) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .section-card-component h6 ){
    color: var(--dark-text) !important;
}

:global(html.dark-theme .section-card-component__eyebrow ){
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .section-card-component small ){
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .section-card-component__icon ){
    background: var(--dark-primary-soft) !important;
    color: #5eead4 !important;
}

:global(html.dark-theme .section-card-component__counter ){
    background: var(--dark-primary-soft) !important;
    color: var(--dark-text) !important;
}

@media (max-width: 575px) {
    .section-card-component {
        padding: 16px 16px 2px;
    }

    .section-card-component__header {
        flex-direction: column;
    }

    .section-card-component__actions,
    .section-card-component__counter {
        align-self: flex-start;
    }
}
</style>
